
import {post} from './http'
export const saveRankRewardInfo = (params)=>{
    return post('/app/v1/updateRankReward?receiveName='+params.receiveName+'&receiveAddr='+params.receiveAddr+'&receivePhone='+params.receivePhone+'&rewardId='+params.rewardId+'&activityMonth='+params.activityMonth+'&isBuy='+params.isBuy+'&orderNo='+params.orderNo);
}

